import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Cart(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.76 19.358c.804 0 1.46.654 1.46 1.46a1.46 1.46 0 11-1.46-1.46zm9.334 0c.805 0 1.46.654 1.46 1.46a1.46 1.46 0 01-2.92 0c0-.806.655-1.46 1.46-1.46zM4.628 2a1 1 0 01.983.816l.245 1.31h15.891a1 1 0 011 1v3.321c-.006 2.068-.158 5.214-3.524 5.647l-11.426.327c.193.726.622 1.783 1.49 1.783h11.538a1 1 0 010 2H9.286c-2.47 0-3.427-2.61-3.603-4.15l-.065-.35a.997.997 0 01-.025-.128L3.798 4H2a1 1 0 110-2h2.628zm16.12 4.127H6.23l1.18 6.304 11.655-.33c1.508-.197 1.683-1.411 1.681-3.94V6.127z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoCart = React.memo(Cart);
export default MemoCart;